<template>
  <div class="row">
    <div class="col-md-12">
      <ul v-if="anyFilters" class="stored-filters">
        <li
          v-for="(filterValue, displayName) in selectedFilters"
          :key="filterValue"
          class="stored-filter"
        >
          <span class="filter-button">
            {{ displayName }}
            <i
              class="glyphicon glyphicon-remove-sign clickable-glyph"
              @click="unselectFilter(filterValue, displayName)"
            />
          </span>
        </li>
        <li class="clear-all">
          <a @click="$emit('clear-all')">
            Clear All
          </a>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
  export default {
    props: {
      selectedFilters: {
        type: Object,
        required: true
      }
    },
    computed: {
      anyFilters() {
        return Object.keys(this.selectedFilters).length > 0;
      }
    },
    methods: {
      unselectFilter(filterValue, displayName) {
        this.$emit('toggle-filter', { displayName, filterValue });
      }
    }
  }
</script>
